export default "__VITE_ASSET__a2d4673d__"